import { render, staticRenderFns } from "./provincial.vue?vue&type=template&id=0c2ab0d2&scoped=true"
import script from "./provincial.vue?vue&type=script&lang=js"
export * from "./provincial.vue?vue&type=script&lang=js"
import style0 from "./provincial.vue?vue&type=style&index=0&id=0c2ab0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ab0d2",
  null
  
)

export default component.exports